import { fetchGet, fetchPost, fetchPatch } from "@/lib/services";

export async function createChild(data: any) {
  return await fetchPost("/child/", data);
}

export async function getChildren(username: string) {
  return await fetchGet(`/child/?Username=${username}`);
}

export async function getChildrenForLeave(name: string) {
  return await fetchGet(`/child/?Name=${name}`);
}

export async function updateChild(id: number, data: any) {
  return await fetchPatch(`/child/?Id=${id}`, data);
}


export async function updateChildVerification(id: number, data: any) {
  return await fetchPatch(`/verfication/?Id=${id}`, data);
}

export async function getParentProfile(username: string) {
  return await fetchGet(`/registeredprofiles/?Username=${username}`);
}

export async function updateParentProfile(id: number, data: any, isMultipart = false) {
  return await fetchPatch(`/registeredprofiles/?Id=${id}`, data, isMultipart);
}

export async function getVerificationList(page?: number, search?: string, status?: 'True' | 'False' | 'Expired') {
  const params = new URLSearchParams();
  if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());
  if (status !== undefined) params.append('Status', status);
  const query = params.toString() ? `?${params.toString()}` : '';
  return await fetchGet(`/verfication/${query}`);
}

export async function getParentLeaves(username?: string) {
  const query = username ? `?Username=${username}` : '';
  return await fetchGet(`/parentleaves/${query}`);
}

export async function applyParentLeave(data:any) {
  return await fetchPost('/parentleaves/',data)
}

export async function cancelLeaveRequest(id: number, data: any) {
  return await fetchPatch(`/parentleaves/?Id=${id}`,data)
}

export async function cancelAllLeaveRequests(leave_id: string, data: any) {
  return await fetchPatch(`/parentleaves/?Leave_Id=${leave_id}`, data);
}

export async function sendLunchReadyUpdate(data:any) {
  return await fetchPost('/lunchupdate/',data)
}

export async function getLunchStatus(username: string) {
  return await fetchGet(`/lunchupdate/?Username=${username}`);
}

export async function getMyLunchUpdates() {
  return await fetchGet(`/parent-lunch-updates/`);
}

export async function getLunchHistory(month: number, year: number) {
  return await fetchGet(`/parent-lunch-updates/?Month=${month}&Year=${year}`);
}

export async function getNotifications(username: string) {
  return await fetchGet(`/notifications/?Username=${username}`);
}

export async function getChildrenForLunchUpdate(){
  return await fetchGet(`/children/`)
}

export async function getUnAssignedChildren(Branch_Code: string, Zone_Code: string) {
  const params = new URLSearchParams();
  if (Branch_Code) params.append('Branch_Code', Branch_Code.trim());
  if (Zone_Code) params.append('Zone_Code', Zone_Code.trim());
  const query = params.toString() ? `?${params.toString()}` : '';
  return await fetchGet(`/unassigned-children/${query}`)
}

export async function getDeliveryAgentsByChild() {
  return await fetchGet('/delivery-boys-parent/')
}

export async function getDiscountCheckForChildService(
  username: string,
  planName: string,
  range: string,
  type: 'Subscribed' | 'Renewal', price:string
) {
  const params = new URLSearchParams({
    Username: username,
    Plan_Name: planName,
    Range: range,
    Type: type, Price:price
  });

  return await fetchGet(`/discount-check/?${params.toString()}`);
}

export async function getChildHistoryService(ChildId:string) {
  return await fetchGet(`/child-history/?Child_Id=${ChildId}`)
}